var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navigation-menu"},_vm._l((_vm.menu),function(li){return (li.is_published == 1 && li.is_show_in_menu == 1 && li.parent_id == _vm.parent)?_c('li',{class:{'link-home' : li.full_path === '/'}},[_c('router-link',{attrs:{"to":li.full_path}},[_vm._v(_vm._s(li.name))])],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f76f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMenu.vue
// module id = ludc
// module chunks = 0